/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyImplantReturnBillItem from './pharmacy-implant-return-bill-item';
import PharmacyImplantReturnBillItemDetail from './pharmacy-implant-return-bill-item-detail';
import PharmacyImplantReturnBillItemUpdate from './pharmacy-implant-return-bill-item-update';
import PharmacyImplantReturnBillItemDeleteDialog from './pharmacy-implant-return-bill-item-delete-dialog';

const PharmacyImplantReturnBillItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyImplantReturnBillItem />} />
    <Route path="new" element={<PharmacyImplantReturnBillItemUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyImplantReturnBillItemDetail />} />
      <Route path="edit" element={<PharmacyImplantReturnBillItemUpdate />} />
      <Route path="delete" element={<PharmacyImplantReturnBillItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyImplantReturnBillItemRoutes;
